class Delay {
    static Sleep = (delay: number): Promise<void> =>
        new Promise((resolve) => setTimeout(resolve, delay));
}

export default Delay;
